import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as currentFactSheets from '../reducers';
import * as fromCurrentFactSheet from '../reducers/get-current-factsheet.reducer';

export const selectCurrentFactSheetsRequest = createSelector(
  currentFactSheets.selectGetCurrentFactSheetState,
  fromCurrentFactSheet.selectCurrentFactSheets
);

export const selectAllCurrentFactSheetsLoaded = createSelector(
  currentFactSheets.selectGetCurrentFactSheetState,
  fromCurrentFactSheet.selectCurrentFactSheetsLoaded
);

export const selectAllCurrentFactSheetsFailure = createSelector(
  currentFactSheets.selectGetCurrentFactSheetState,
  fromCurrentFactSheet.selectCurrentFactSheetsError
);
